<script setup lang="ts">
import {ModelList} from '@jantm/model-core'
import Dashboard from "@/components/WiserDashboardComponent.vue";
import {ref} from "vue";
import type {CertificateFilter} from "@/types/Wiser/certificate.ts";
import CertificateFilterForm from "@/views/Wiser/CertificateFilterForm.vue";
const modelFilter = ref<CertificateFilter>({page: '1', perPage: '25'});
</script>

<template>
  <Dashboard />
  <div class="container">
    <CertificateFilterForm v-model="modelFilter" />
    <ModelList class="model-list model-list-certificate" model="Certificate" :filter="modelFilter" />
  </div>
</template>

<style scoped></style>
